import React, { useState } from "react";
import styles from "../styles/Retail.module.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import pic from "../assets/smartPos.JPG";
import payment from "../assets/Rem.jpg";
import view from "../assets/POS2.JPG";
import imag from "../assets/t2.JPG";
import { Link } from "react-router-dom";

const Retail = () => {
  const [activeButton, setActiveButton] = useState("Payment in Store");

  const getContent = (buttonText) => {
    switch (buttonText) {
      case "Payment on the go":
        return (
          <>
            <h3 className={styles.sideTextHeading}>Mobile POS Solutions</h3>
            <p className={styles.sideTextParagraph}>
              <span className={styles.icon}>✦</span> Enable staff to accept
              payments anywhere in the store, improving customer experience.
            </p>
            <h3 className={styles.sideTextHeading}>Contactless Payments</h3>
            <p className={styles.sideTextParagraph}>
              <span className={styles.icon}>✦</span> Support for mobile wallets,
              and tap-to-pay solutions.
            </p>
          </>
        );

      case "Self Service":
        return (
          <>
            <h3 className={styles.sideTextHeading}>Self-Checkout Kiosks</h3>
            <p className={styles.sideTextParagraph}>
              <span className={styles.icon}>✦</span> Allow customers to scan and
              pay for their items independently.
            </p>
            <h3 className={styles.sideTextHeading}>
              Automated In-Store Ordering
            </h3>
            <p className={styles.sideTextParagraph}>
              <span className={styles.icon}>✦</span> Digital kiosks for in-store
              pickup and pre-ordering.
            </p>
          </>
        );

      case "Commerce Service":
        return (
          <>
            <h3 className={styles.sideTextHeading}>
              Inventory & Store Management
            </h3>
            <p className={styles.sideTextParagraph}>
              <span className={styles.icon}>✦</span> Stock tracking and demand
              forecasting.
            </p>
            <h3 className={styles.sideTextHeading}>
              Loyalty & Rewards Programs
            </h3>
            <p className={styles.sideTextParagraph}>
              <span className={styles.icon}>✦</span> Digital solutions for
              customer engagement, offering discounts and reward points.
            </p>
          </>
        );

      default:
        return (
          <>
            <h3 className={styles.sideTextHeading}>
              Smart POS & Countertop Payments
            </h3>
            <p className={styles.sideTextParagraph}>
              <span className={`${styles.icon} ${styles.green}`}>✦</span>{" "}
              Secure, quick transactions at checkout counters to reduce waiting
              time.
            </p>
            <h3 className={styles.sideTextHeading}>QR Code Payments</h3>
            <p className={styles.sideTextParagraph}>
              <span className={styles.icon}>✦</span> Customers can scan a QR
              code for instant payments, reducing reliance on cash.
            </p>
          </>
        );
    }
  };

  return (
    <div>
      <Header />
      <div className={styles.empoweringSection}>
        <div className={styles.hero}>
          <div className={styles.heroContent}>
            <p style={{ fontSize: "30px", fontWeight:"bold" }} className={styles.msmesLabel}>
              RETAIL
            </p>
            <h1 className={styles.heroTitle}>
              Payment Solution For
              Reatil And Large Shops
            </h1>
            <button className={styles.contactButton}>Contact Us →</button>
          </div>
          <div className={styles.heroImage}>
            <img
              style={{
                borderRadius: "50px",
                marginRight: "250px",
                width: "500px",
                height: "300px",
              }}
              src={pic}
              alt="Payment terminal in a shop"
            />
          </div>
        </div>
      </div>
      <div className={styles.helpingSection}>
        <div className={styles.helpingText}>
          <h2 className={styles.helpingTitle}>
            Enhancing The Customer
            <br />
            Experience
          </h2>
          <p className={styles.helpingDescription}>
            We are a trusted partner of the country's leading retail brands,
            with customers all over the country. We help business of all sizes
            connect with the next generation of consumers, regardless of thier
            segment.
          </p>
        </div>
      </div>

<div className={styles.contents}>
  {/* Section 1 - Image Left, Text Right */}
  <section className={styles.thirdLayer}>
    <div
      className={styles.newContent}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "160px",
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "40px 20px"
      }}
    >
      <div className={styles.solutionImage}>
        <img
          src={payment}
          alt="feature payment"
          style={{
            width: "550px",
            height: "250px",
            borderRadius: "15px",
            objectFit: "cover"
          }}
        />
      </div>
      <div className={styles.viewText} style={{ maxWidth: "600px" }}>
        <h2 style={{ 
          fontSize: "24px", 
          color: "#333", 
          marginBottom: "20px",
          lineHeight: "1.3"
        }}>
          Create a Great Shopping Experience
        </h2>
        <p style={{ fontSize: "20px", color:"black"}}>Delight your customers from checkout to goodbye.</p>
        <p style={{ 
          fontSize: "17px", 
          color: "black",
          lineHeight: "1.6"
        }}>
          <span className={styles.icon}>✦</span>Our smart solutions deliver a smooth, omnichannel journey that keeps customers coming back no matter your store size or location.

Seamless in store payment flow,

User friendly, queue busting checkout,

Integrated with your preferred <span className={styles.NewmobileBreak}><br/></span> systems
          <br /><br />
          {/* <span className={styles.icon}>✦</span> Our reliable and user-friendly payment solutions improve queue-busting and make checkouts quick and easy. */}
        </p>
      </div>
    </div>
  </section>

  {/* Section 2 - Text Left, Image Right */}
  <section className={styles.thirdLayer}>
    <div
      className={styles.newContentReverse}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexDirection: "row-reverse",
       gap: "160px",
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "40px 20px"
      }}
    >
      <div className={styles.solutionImageReverse}>
        <img
          src={imag}
          alt="advanced payment"
          style={{
            width: "450px",
            height: "250px",
            borderRadius: "15px",
            border: "6px solid rgba(143, 188, 143, 0.3)",
            objectFit: "cover"
          }}
        />
      </div>
      <div className={styles.viewTextReverse} style={{ maxWidth: "600px" }}>
        <h2 style={{ 
          fontSize: "24px", 
          color: "#333", 
          marginBottom: "20px",
          lineHeight: "1.3"
        }}>
          Adapt To Your Customers
        </h2>
           <p style={{fontSize:'20px', color:"black"}}>Let customers pay their way<span className={styles.NewmobileBreak}><br/></span> every time.</p>
        <p style={{ 
          fontSize: "16px", 
          color: "black",
          lineHeight: "1.6",
          marginBottom: "15px"
        }}>
          <span className={styles.icon}>✦</span> Empower every shopper with flexible payment options, including cards, QR, wallets, and alternative methods. Our platform is built to serve all preferences.

Accept tap, scan, swipe, or  collect,

Supports self-checkout and click & collect,

Inclusive payment experiences that grow loyalty.
        </p>
        <p style={{ 
          fontSize: "1.2rem", 
          color: "black",
          lineHeight: "1.6"
        }}>
          {/* <span className={styles.icon}>✦</span> Our devices accept all payment methods, from contactless payments to click-and-collect, self-checkout, and alternative payment methods (APMs), to meet your customers' needs. */}
        </p>
      </div>
    </div>
  </section>

  {/* Section 3 - Image Left, Text Right */}
  <section className={styles.thirdLayer}>
    <div
      className={styles.newContent}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
     gap: "160px",
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "40px 20px"
      }}
    >
      <div className={styles.solutionImage}>
        <img
          src={view}
          alt="feature payment"
          style={{
            width: "450px",
            height: "250px",
            borderRadius: "15px",
            objectFit: "cover"
          }}
        />
      </div>
      <div className={styles.viewText} style={{ maxWidth: "600px" }}>
        <h2 style={{ 
          fontSize: "24px", 
          color: "#333", 
          marginBottom: "20px",
          lineHeight: "1.3"
        }}>
          Integrate Your Retail Environment
        </h2>
          <p style={{fontSize:'20px', color:"black"}}>Built to fit your store’s existing setup.</p>
     
        <p style={{ 
          fontSize: "16px", 
          color: "black",
          lineHeight: "1.6"
        }}>
          <span className={styles.icon}>✦</span> Our POS terminals and APIs integrate with your printers, cash registers, and inventory systems without disruption.

Plug-and-play terminal integration,

Scalable APIs for fast deployment,

Compatible with global and local infrastructure.
          <br /><br />
          {/* <span className={styles.icon}>✦</span> Thanks to our global APIs, our solutions will be a perfect fit for your current printers, ECR systems, and more. */}
        </p>
      </div>
    </div>
  </section>

  {/* Section 4 - Text Left, Graphic Right */}
  <section className={styles.thirdLayer}>
    <div
      className={styles.newContentReverse}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexDirection: "row-reverse",
        gap: "60px",
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "40px 20px"
      }}
    >
      <div className={styles.supportImage} style={{ width: "300px" }}>
        <div style={{
          position: "relative",
          width: "300px",
          height: "250px",
          overflow:'hidden',
          margin: "0 auto"
        }}>
          <div style={{
            position: "absolute",
            top: "10%",
            left: "10%",
            right: "10%",
            bottom: "10%",
            borderRadius: "15px",
            backgroundColor: "white",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}>
            <div style={{
              width: "60px",
              height: "60px",
              borderRadius: "50%",
              backgroundColor: "#e0f7fa",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "10px"
            }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="#00bcd4"
                style={{ width: "30px", height: "30px" }}
              >
                <path d="M12 4a4 4 0 0 1 4 4v6c0 1.1-.9 2-2 2h-4c-1.1 0-2-.9-2-2V8a4 4 0 0 1 4-4m0 14c-2 0-3.7-1.3-4-3h8c-.3 1.7-2 3-4 3m6-10v2h2v-2h-2m-10 0v2h2v-2H6z" />
              </svg>
            </div>
            <p style={{ 
              fontSize: "0.9rem", 
              color: "black", 
              marginBottom: "5px" 
            }}>
              Customer Support
            </p>
            <strong style={{ 
              fontSize: "2.5rem", 
              color: "#333" 
            }}>
              9395
            </strong>
          </div>
          <div style={{
            position: "absolute",
            top: "-10%",
            left: "-10%",
            width: "120%",
            height: "120%",
            borderRadius: "50%",
            border: "2px solid #a7f0a7",
            opacity: "0.7"
          }}></div>
          <div style={{
            position: "absolute",
            top: "-20%",
            left: "-20%",
            width: "140%",
            height: "140%",
            borderRadius: "50%",
            border: "2px solid #a7f0a7",
            opacity: "0.5"
          }}></div>
        </div>
      </div>
      <div className={styles.viewTextReverse} style={{ maxWidth: "600px" }}>
        <h2 style={{ 
          fontSize: "24px", 
          color: "#333", 
          marginBottom: "20px",
          lineHeight: "1.3"
        }}>
          Stay Open For Business, 24/7
        </h2>
           <p style={{fontSize:'20px', color:"black"}}>Because retail never sleeps.</p>
        <p style={{ 
          fontSize: "16px", 
          color: "black",
          lineHeight: "1.6",
          marginBottom: "15px"
        }}>
          <span className={styles.icon}>✦</span>Ensure uptime and operational continuity with our 24/7 support and cloud-connected dashboard track, monitor, and resolve in real time.

Always-on support and remote updates,

Real-time business health monitoring,<span className={styles.NewmobileBreak}><br/></span>

Secure system access from anywhere.
        </p>
        <p style={{ 
          fontSize: "1.2rem", 
          color: "black",
          lineHeight: "1.6"
        }}>
          {/* <span className={styles.icon}>✦</span> A single platform allows you to track and monitor your estate, keeping your business running 24/7. */}
        </p>
      </div>
    </div>
  </section>
</div>

      <section className={styles.buttonSection}>
        <div className={styles.buttonContainer}>
          <div className={styles.buttonText}>
            <p className={styles.subheading}>
              FASTER, SAFER, AND SMARTER SOLUTIONS
            </p>
            <h2 className={styles.buttonHeader}>Industry Specific Solutions</h2>
            <p className={styles.buttonParagraph}>
            Retail success depends on smooth, reliable transactions. Our payment systems enable secure, rapid, and automated sales whether in-store or online helping retailers deliver a hassle-free shopping experience.
            </p>
          </div>

          <div className={styles.buttonAndText}>
            <div className={styles.buttonGroup}>
              <div className={styles.mobileButtonSlider}>
                {[
                  "Payment in Store",
                  "Payment on the go",
                  "Self Service",
                  "Commerce Service",
                ].map((btn) => (
                  <button
                    key={btn}
                    className={`${styles.industryButton} ${
                      activeButton === btn ? styles.activeIndustryButton : ""
                    }`}
                    onClick={() => setActiveButton(btn)}
                    style={{
                      backgroundColor:
                        activeButton === btn ? "var(--primary-green)" : "",
                      color: activeButton === btn ? "white" : "",
                    }}
                  >
                    {btn} <span className={styles.buttonIcon}>→</span>
                  </button>
                ))}
              </div>
            </div>

            <div className={styles.mobileButtonContent}>
              {getContent(activeButton)}
            </div>
          </div>
        </div>
      </section>

      <section className={styles.bottom}>
        <div
          className={styles.bottom}
          style={{
            backgroundColor: "var(--primary-green)",
            color: "#fff",
            padding: "20px 30px",
            borderRadius: "35px",
            margin: "40px 70px 65px 50px",
          }}
        >
          <div
            style={{
              maxWidth: "1200px",
              margin: "0 auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            {/* Text Content */}
            <div style={{ flex: "1", maxWidth: "550px", marginBottom: "30px" }}>
              <h2
                style={{
                  fontSize: "2em",
                  marginBottom: "15px",
                  color: "white",
                }}
              >
                It Starts With Your Business
                <br />
                Account
              </h2>
              <p
                className={styles.helpingDescription}
                style={{ fontSize: "0.9em", color: "white" }}
              >
                <span style={{ color: "white", fontSize: "0.6em" }}>✦</span>{" "}
                Join our merchants.
              </p>
              <Link to="/become-a-merchant">
              <button
                className={styles.but}
                style={{
                      backgroundColor: "#fff",
                      color: "green",
                      border: "none",
                      padding: "15px 30px",
                      borderRadius: "5px",
                      fontSize: "16px",
                      fontWeight: "bold",
                      cursor: "pointer",
                    }}
              >
                Register Now →
              </button>
              </Link>
            </div>

            {/* Image Side */}
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <img
                src={view}
                alt="Payment Terminal"
                style={{
                  width: "100%",
                  maxWidth: "450px",
                  height: "auto",
                  objectFit: "cover",
                  borderRadius: "25px",
                  border: "5px solid green",
                }}
              />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Retail;
